import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { format } from 'date-fns';
import MobileGameUmpire from './MobileGameUmpire';
import ErrorPopup from './ErrorPopup';
import './SelectedGameMobile.css';

class SelectedGameMobile extends Component {

  render() {
    const {
      umpires,
      umpiresList,
      umpiresFetchStatus,
      memberId, umpireLevel,
      removeUmp,
      assignUmpToGame,
      userType,
      selectedGame, seasonDivisions,
      mobile,
    } = this.props;

    if (selectedGame && selectedGame !== null) {
      const division = seasonDivisions[selectedGame.divisionId];
      
      return (
        <div className="selected-game-container">
          <div className="selected-game-container-header">
            {mobile.page === 'home' ? 
              <Link className="back-to-games-button" to="/">
                Back to Games
              </Link>
            :
              <Link className="back-to-games-button" to="/my-games">
                Back to Games
              </Link>
            }
          </div>
          <div className="selected-game-container-body">
            {selectedGame.cancelled &&
              <div className="row">
                <h2 className="left" style={{color: "red"}}>
                  CANCELLED
                </h2>
              </div>
            }
            <div className="row">
              <Typography variant="subtitle1">
                {format(selectedGame.startDate, 'ddd MMM D, h:mm a')} @ {selectedGame.facilityName}
              </Typography>
            </div>
            <div className="row">
              <Typography variant="subtitle1">
                {selectedGame.divisionName}
              </Typography>
            </div>
            <div className="row">
              <Typography variant="subtitle1">
                {selectedGame.homeTeamName} (H) vs {selectedGame.awayTeamName} (A)
              </Typography>
            </div>
            <div className="row-game-details">
              <MobileGameUmpire
                selectedGame={selectedGame}
                division={division}
                umpires={umpires}
                umpiresList={umpiresList}
                umpiresFetchStatus={umpiresFetchStatus}
                userType={userType}
                memberId={memberId}
                umpireLevel={umpireLevel}
                position="umpPlate"
                removeUmp={removeUmp}
                assignUmpToGame={assignUmpToGame}
                plate="P"
              />
            </div>
            {(selectedGame.umpAvailable !== null || selectedGame.umpAvailable !== '') &&
            selectedGame.umpAvailable > 1 ? (
              <div className="row-game-details">
                <MobileGameUmpire
                  selectedGame={selectedGame}
                  division={division}
                  umpires={umpires}
                  umpiresList={umpiresList}
                  umpiresFetchStatus={umpiresFetchStatus}
                  userType={userType}
                  memberId={memberId}
                  umpireLevel={umpireLevel}
                  position="umpBase1"
                  removeUmp={removeUmp}
                  assignUmpToGame={assignUmpToGame}
                  plate="B1"
                />
              </div>
            ) : (
              <div />
            )}
            {(selectedGame.umpAvailable !== null || selectedGame.umpAvailable !== '') &&
            selectedGame.umpAvailable > 2 ? (
              <div className="row-game-details">
                <MobileGameUmpire
                  selectedGame={selectedGame}
                  division={division}
                  umpires={umpires}
                  umpiresList={umpiresList}
                  umpiresFetchStatus={umpiresFetchStatus}
                  userType={userType}
                  memberId={memberId}
                  umpireLevel={umpireLevel}
                  position="umpBase2"
                  removeUmp={removeUmp}
                  assignUmpToGame={assignUmpToGame}
                  plate="B2"
                />
              </div>
            ) : (
              <div />
            )}
            {(selectedGame.umpAvailable !== null || selectedGame.umpAvailable !== '') &&
            selectedGame.umpAvailable > 3 ? (
              <div className="row-game-details">
                <MobileGameUmpire
                  selectedGame={selectedGame}
                  division={division}
                  umpires={umpires}
                  umpiresList={umpiresList}
                  umpiresFetchStatus={umpiresFetchStatus}
                  userType={userType}
                  memberId={memberId}
                  position="umpBase3"
                  removeUmp={removeUmp}
                  assignUmpToGame={assignUmpToGame}
                  plate="B3"
                />
              </div>
            ) : (
              <div />
            )}
            {this.props.error !== null ? (
              <div>
                <ErrorPopup error={this.props.error} clearErrors={this.props.clearErrors} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

export default SelectedGameMobile;



// WEBPACK FOOTER //
// ./src/components/SelectedGameMobile.js